import React, { useState, createContext, useContext } from "react";

const context = {};

export const BusinessContext = createContext(context);

export function BusinessContextProvider(props) {
  const [fetch_user, setFetchUser] = useState(false);
  const [reFetch, setRefetch] = useState(false);

  return (
    <BusinessContext.Provider
      value={{
        refetch: () => setRefetch((_) => !_),
        fetchUser: () => setFetchUser(() => !fetch_user),
        fetch: reFetch,
      }}
    >
      {props.children}
    </BusinessContext.Provider>
  );
}
export const useBusinessContext = () => {
  return useContext(BusinessContext);
};
